import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const CtaSection = ({ headline, subtext, buttonText, testid }) => (
  <section data-testid={testid} className="bg-[#0B0F19]">
    <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl"
      >
        {headline}
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
        className="mt-5 max-w-xl text-lg leading-relaxed text-slate-400"
      >
        {subtext}
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.22, ease: [0.22, 1, 0.36, 1] }}
      >
        <Link
          to="/contact"
          data-testid={`${testid}-button`}
          className="group mt-10 inline-flex items-center gap-2 rounded-full bg-kinetic px-8 py-4 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-kinetic-hover"
        >
          {buttonText}
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </motion.div>
    </div>
  </section>
);
